import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import messages from 'components/MyContractInfo/AMCPersonalInfo/messages';
import {
  StyledCaption,
  StyledPaper,
  StyledShortBody,
} from 'components/MyContractInfo/styles';
import { get } from 'lodash';
import React, { ReactNode } from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';

interface PersonalInfoItemProps {
  label: string;
  value: string | ReactNode;
}
const PersonalInfoItem = ({ value, label }: PersonalInfoItemProps) => {
  const { formatMessage } = useIntl();

  return (
    <Grid item sm={6} md={6}>
      <Grid container direction="column">
        <Grid item>
          <StyledCaption>{formatMessage(get(messages, label))}</StyledCaption>
        </Grid>
        <Grid item>
          <Box marginBottom={2}>
            {typeof value === 'string' ? (
              <StyledShortBody>{value}</StyledShortBody>
            ) : (
              value
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface AMCPersonalInfoType {
  intl: IntlShape;
  regulationMode: string;
  rib: string;
  adresse: string;
}
const AMCPersonalInfo = (props: AMCPersonalInfoType) => {
  const { rib, regulationMode, adresse } = props;
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const parentDirection = matches ? 'row' : 'column';
  const childDirection = matches ? 'column' : 'row';

  return (
    <StyledPaper>
      <Box padding={2}>
        <Grid justify="space-between" direction={parentDirection}>
          <Grid item xs={12} sm={12}>
            <Grid container direction={childDirection}>
              <PersonalInfoItem
                label="regulationMode"
                value={
                  regulationMode === 'V'
                    ? formatMessage({ id: 'amc.details.wire' })
                    : formatMessage({ id: 'amc.details.mandat' })
                }
              />
              {regulationMode === 'V' && (
                <PersonalInfoItem label="rib" value={rib} />
              )}
            </Grid>
          </Grid>
          <Grid justify="flex-end" item xs={12} sm={12}>
            <Grid container direction={childDirection}>
              <PersonalInfoItem label="adresse" value={adresse} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <StyledCaption>
            {formatMessage({ id: 'amc.adhesion.informations' })}
          </StyledCaption>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default injectIntl(AMCPersonalInfo);
